const LOOPBACK_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]"]);

export function shouldForcePasscode(
  hostname: string,
  runtimeFlag: unknown,
  envFlag: string | undefined,
): boolean {
  return (
    LOOPBACK_HOSTNAMES.has(hostname) &&
    (runtimeFlag === true || envFlag === "true")
  );
}
